import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const FourYear: FC = () => {
  return (
    <Box mt={1}>
        <Header>
            <Box display={'flex'}>
                <Typography mb={1} ml={2}>Возраст</Typography>
                <Typography mb={1} ml={20}>Специалисты</Typography>
                <Typography mb={1} ml={20}>Виды обследования</Typography>
            </Box>
            <Box display='flex'>
                <TextField
                    label="1 месяц"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="2 месяца"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="3 месяца"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="4 месяца"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="5 месяца"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="6 месяцев"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="7 месяцев"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="8 месяцев"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="9 месяцев"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="10 месяцев"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="11 месяцев"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="12 месяцев"
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mr: 1, mb: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
            </Box>
        </Header>
    </Box>
  );
};

export default FourYear;